// extracted by mini-css-extract-plugin
export default {"requiredCheckbox":"BudgetFieldScreen_requiredCheckbox__AEKUA","dragIconContainer":"BudgetFieldScreen_dragIconContainer__fm2DL","dragIcon":"BudgetFieldScreen_dragIcon__C9F3r"};